import React from "react";
import { useHistory } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./BackButton.css";

function BackButton({ to, label = "Voltar", className = "" }) {
  const history = useHistory();

  const handleClick = () => {
    if (to) {
      // Adiciona barra final se não existir
      const path = to.endsWith('/') ? to : `${to}/`;
      history.push(path);
    } else {
      history.goBack();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`back-button ${className}`}
      title={label}
    >
      <FaArrowLeft style={{ marginRight: "8px" }} />
      {label}
    </button>
  );
}

export default BackButton;
